import { render } from "./MerchantCooperation.vue?vue&type=template&id=191668c4&scoped=true"
import script from "./MerchantCooperation.vue?vue&type=script&lang=js"
export * from "./MerchantCooperation.vue?vue&type=script&lang=js"

import "./MerchantCooperation.vue?vue&type=style&index=0&id=191668c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-191668c4"]])

export default __exports__